// Dependencies
import { createGlobalStyle } from 'styled-components';

import QuasimodaLightWoff2 from '../../fonts/6209375/4168b16d-5024-46d0-922a-ae21966a2784.woff2';
import QuasimodaLightWoff from '../../fonts/6209375/ab95d28c-a889-4a51-9888-bf05d972de13.woff';

import QuasimodaRegularWoff2 from '../../fonts/6209381/03f42206-6156-48ee-993d-1082ba29543a.woff2';
import QuasimodaRegularWoff from '../../fonts/6209381/cef3f7e4-d4f3-48ea-b532-61ecfca6b12d.woff';

import QuasimodaRegularItalicWoff2 from '../../fonts/6209417/9bd77f0a-3ed7-4be8-adeb-633f511ba66a.woff2';
import QuasimodaRegularItalicWoff from '../../fonts/6209417/a06e8dac-2517-4ee0-8e76-00b63d2a6fa7.woff';

import QuasimodaMediumWoff2 from '../../fonts/6209384/ac690c5a-cc43-4b72-953d-b270d8c2d13d.woff2';
import QuasimodaMediumWoff from '../../fonts/6209384/9dd37b4c-8cea-425d-b7bd-c91933b3f34e.woff';

import QuasimodaBoldWoff2 from '../../fonts/6209393/3ca470fd-8270-41e1-a8a8-1ab7f428bf19.woff2';
import QuasimodaBoldWoff from '../../fonts/6209393/d8f39457-732a-49f3-8a19-b484a9d46ffa.woff';

import QuasimodaBoldItalicWoff2 from '../../fonts/6209423/824b59ad-ee2f-4078-9740-d119f90b29be.woff2';
import QuasimodaBoldItalicWoff from '../../fonts/6209423/ee970c43-6dcc-47fc-b87f-089c8666389f.woff';

const TypographyStyles = createGlobalStyle`
/*
* Quasimoda light
*/
@font-face{
  font-family: 'Quasimoda';
  src:url(${QuasimodaLightWoff2}),url(${QuasimodaLightWoff});
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}

/*
* Quasimoda regular
*/
@font-face{
  font-family: 'Quasimoda';
  src:url('${QuasimodaRegularWoff2}') format('woff2'), url(${QuasimodaRegularWoff}) format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/*
* Quasimoda regular italic
*/
@font-face{
  font-family: 'Quasimoda';
  src:url('${QuasimodaRegularItalicWoff2}') format('woff2'), url(${QuasimodaRegularItalicWoff}) format('woff');
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}

/*
* Quasimoda medium
*/
@font-face{
  font-family: 'Quasimoda';
  src:url('${QuasimodaMediumWoff2}') format('woff2'), url(${QuasimodaMediumWoff}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

/*
* Quasimoda bold
*/
@font-face{
  font-family: 'Quasimoda';
  src:url('${QuasimodaBoldWoff2}') format('woff2'), url(${QuasimodaBoldWoff}) format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/*
* Quasimoda bold italic
*/
@font-face{
  font-family: 'Quasimoda';
  src:url(${QuasimodaBoldItalicWoff2}) format('woff2'), url(${QuasimodaBoldItalicWoff}) format('woff');
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}

html,
body {
  font-family: 'Quasimoda', sans-serif;
  font-size: 16px;
  font-display: swap;
  color: var(--color-charcoal);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-weight: var(--font-weight-light);
  text-transform: uppercase;
}

h1,
h2.large,
h3.large {
  margin: 0 0 1.5rem;
  line-height: 2.063rem;
  letter-spacing: 0.035rem;
}

h1,
h2.large,
h3.large {
  font-size: 1.313rem;
}

h5,
h6 {
  font-size: 0.875rem;
}

h2 {
  margin: 0 0 1.5rem;
  font-size: 0.875rem;
  line-height: 1.6rem;
  letter-spacing: 0.035rem;

  &.large-mobile {
    font-size: 1rem;
  }
}

h3,
h4,
h5,
h6 {
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.035rem;
}

h3 {
  margin: 0 0 1.063rem;
  font-size: 1rem;
  line-height: 1.438rem;
}

h4,
h5,
h6 {
  margin: 0 0 0.3rem;
  line-height: 1.65;
}

h4 {
  font-size: 0.8rem;
}

p,
ul li,
ol li,
a {
  font-size: 0.938rem;
  line-height: 1.9;
  letter-spacing: 0.003rem;

  &:last-child {
    margin: 0;
  }
}

p {
  margin: 0 0 1.5rem;
}

a {
  text-decoration: none;
  color: var(--color-bark);
  transition: color .4s;

  &:hover,
  &:focus {
    color: var(--color-graphite);
  }
}

strong,
b {
  font-weight: var(--font-weight-medium);
}

@media(min-width: 992px) {
  h1,
  h2.large,
  h3.large {
    margin: 0 0 1.75rem;
    font-size: 1.625rem;
    line-height: 2.688rem;
    letter-spacing: 0.058rem;
  }

  h2,
  h3,
  h5,
  h6 {
    font-size: 1.25rem;
    line-height: 1.6;
  }

  h2,
  h3,
  h5,
  h6 {
    margin: 0 0 1.188rem;
    letter-spacing: 0.05rem;

    &.large-mobile {
      font-size: 1.25rem;
    }
  }

  h4,
  h5,
  h6 {
    margin: 0 0 0.3rem;
  }

  h4 {
    font-size: 1rem;
  }

  p,
  ul li,
  a {
    font-size: 1.125rem;
    letter-spacing: 0.005rem;
  }

  p {
    margin: 0 0 1.7rem;
  }
}
`;

export default TypographyStyles;
